import { useState, useCallback } from "react";

type FeedSeed = {
  // null → the server derives a per-(user, UTC day) default, so an un-refreshed
  // feed is stable within the day. Non-null → a client-minted seed that holds
  // across pages (coherent infinite scroll) until the next refresh.
  seed: string | null;
  refresh: () => void;
};

// Recommender v2 — Phase 4. Owns the for-you feed's daily-refresh seed: the
// rotation knob the API reads to reorder the ranked pool (seeded jitter +
// anti-repetition). Ephemeral UI state by design — a refreshed feed should not
// survive a reload — so it lives in a dedicated hook rather than a store.
export function useFeedSeed(): FeedSeed {
  const [seed, setSeed] = useState<string | null>(null);
  const refresh = useCallback(() => {
    setSeed(crypto.randomUUID());
  }, []);
  return { seed, refresh };
}
